// extracted by mini-css-extract-plugin
export default {"itemContainer":"CertificationItem_itemContainer__KhyzW"};